import "./order-card-ready.scss";

import classNames from "classnames";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { FunctionComponent, MouseEvent } from "react";

import { ModalCardHeader } from "@client/components/modals-ui/modal-card-header";
import { CheckMark } from "@client/components/reusable/check-mark/check-mark";
import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as AttentionIcon } from "@client/components/reusable/SvgIcons/library/attention_icon.svg";
import { ReactComponent as CarIcon } from "@client/components/reusable/SvgIcons/library/car_icon.svg";
import { useRootContext } from "@client/context/RootContext";
import { Order } from "@client/stores";
import { LABELS } from "@client/utils/labels";

import { OrderCardDetails } from "../order-card-details";

interface OrderCardReadyProps {
	order: Order;
	selected?: boolean;
	onSelectedChange?: (orderId: number) => void;
}

export const OrderCardReady: FunctionComponent<OrderCardReadyProps> = observer(
	({ order, selected, onSelectedChange }) => {
		const {
			modalStore,
			vendorStore,
			vendorStore: {
				orderOperations: { collectedOrder },
				vendorDetails: { delivery_dates_select_all },
			},
		} = useRootContext();

		const formattedDate = dayjs(order.dates.scheduled_date).format(
			"DD/MM/YYYY"
		);

		function openReadyModal(e: MouseEvent) {
			e.preventDefault();
			e.stopPropagation();

			modalStore.addModal({
				id: "order-ready-modal-" + order.id,
				showCloseBtn: true,
				content: (
					<div className="ready-to-pick-modal-container">
						<ModalCardHeader order={order} isReadyToPickModal={true} />

						<OrderCardDetails order={order} isReadyToPickModal={true} />
					</div>
				),
			});
		}

		return (
			<div className={classNames("order-container", "ready-tab")}>
				{delivery_dates_select_all && (
					<CheckMark
						selected={selected}
						onClick={() => onSelectedChange?.(order.id)}
					/>
				)}

				<div className="centered-title">{`${order.order_meta.magentoSaleId} | #${order.id}`}</div>
				<div className="centered-subtitle">
					{`${
						order.shipping_details.user_details.firstName
					} ${order.shipping_details.user_details.lastName?.charAt(0)}.`}
				</div>
				<div className="click-area" onClick={openReadyModal}>
					<SvgIcon component={CarIcon} />
					<div className="view-order">
						<div className="view-order-text">View order</div>
					</div>
				</div>

				{order.dates.scheduled_date && (
					<div className="ready-date-container">
						<div className="ready-date-border-line" />
						<>
							<div className="ready-date-text">{LABELS.readyDateText}</div>
							<div className="ready-date-date">{formattedDate}</div>
						</>
					</div>
				)}

				<button
					className="collected-btn"
					onClick={() => {
						vendorStore.setActualDate(order.id);
						collectedOrder?.(order.id);
					}}
				>
					{vendorStore.vendorDetails?.delivery_dates_enabled
						? LABELS.collectedByCourier
						: LABELS.collectedByCourier_pre_delivery_dates}
				</button>
				{vendorStore.vendorDetails?.delivery_dates_enabled && (
					<div className="ready-date-info">
						{" "}
						<SvgIcon component={AttentionIcon} />
						<div>{LABELS.readyDateInfo}</div>
					</div>
				)}
			</div>
		);
	}
);
